import { useCallback, useEffect, useState } from 'react'
import CatalogService, { CatalogApartment } from '../../services/catalog'
import { changeLanguage } from '../../translations/i18n'

const TITLE = 'Rental homes in the Helsinki region | Fiksuvuokraus'

export const useCatalog = () => {
  const [apartments, setApartments] = useState<CatalogApartment[] | undefined>()
  const [error, setError] = useState(false)

  const load = useCallback(async (force = false) => {
    setError(false)
    try {
      const { apartments: list } = await CatalogService.getCatalog(force)
      setApartments(list || [])
    } catch (_error) {
      setError(true)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return { apartments, error, retry: () => load(true) }
}

/** English page chrome; first-time visitors also continue to the application in English. */
export const useCatalogPage = (title = TITLE) => {
  useEffect(() => {
    try {
      if (!localStorage.getItem('language')) changeLanguage('en')
    } catch (_error) {
      // storage unavailable: the page itself is English regardless
    }
  }, [])

  useEffect(() => {
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
